import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
    selector: 'app-clinic-followups',
    templateUrl: './clinic-followups.component.html',
    styleUrls: ['./clinic-followups.component.scss']
})
export class ClinicFollowupsComponent implements OnInit {

    date: any = "";
    followups: any = [];

    constructor(private dataService: DataService) { }

    ngOnInit() {
        this.date = new Date().toISOString().split('T')[0];
        this.loadFollowups();
    }

    loadFollowups() {
        this.dataService.getClinicFollowups(this.date).subscribe((res: any) => {
            if (res.status == 0) {
                this.followups = res.data;
            } else {
                this.followups = [];
            }
        });
    }

}
